import { useRef, useState } from "react";
import { SiMinutemailer } from "react-icons/si";
import React from "react";
import { Modal } from "antd";
import { v4 as uuidv4 } from "uuid";
import "../App.css";

function Contact({ cloudUtils }: any) {
  const [joinTrigger, setJoinTrigger] = useState(false);
  const [commentId, showComment] = useState("");

  const Name = useRef<any>();
  const What = useRef<any>();
  const How = useRef<any>();
  const Email = useRef<any>();

  interface personDetails {
    name: string;
    email: string;
  }
  const [details, setDetails] = useState<personDetails>();

  const sendInvite = () => {
    if (
      Name.current &&
      Email.current &&
      Name.current.value != "" &&
      Email.current.value != ""
    ) {
      const id = uuidv4();
      const details = {
        name: Name.current.value,
        email: Email.current.value,
        created: new Date().toUTCString(),
      };
      cloudUtils.updateDocument("waitlist", id, details).then(() => {
        setJoinTrigger(true);
        setDetails(details);

        setTimeout(() => showComment(id), 2500);
      });
    }
  };

  const addComment = () => {
    if (
      What.current &&
      What.current.value != "" &&
      How.current &&
      How.current.value != ""
    ) {
      cloudUtils
        .updateDocument(
          "waitlist",
          commentId,
          {
            what: What.current.value,
            how: How.current.value,
          },
          "UPDATE"
        )
        .then(() => {
          showComment("");
        });
    }
  };

  function FormComponent() {
    return (
      <>
        <h1 className=" text-2xl mt-10 text-center text-SocoWhite p-0">
          Join our Waitlist
        </h1>
        <label htmlFor="name" className="mb-2 text-start">
          Name
        </label>
        <input
          type="text"
          name="fullname"
          id="name"
          className=" rounded-full h-10 p-5 text-center text-SocoBlack"
          ref={Name}
        />

        <label htmlFor="email" className=" mt-5 mb-2 text-start ">
          Email
        </label>
        <input
          type="email"
          name="email"
          id="email"
          className=" rounded-full h-10 p-5 text-center text-SocoBlack"
          ref={Email}
        />

        <div className="p-5">
          <button
            className="h-10 w-24 rounded-full text-SocoBlack bg-SocoWhite font-semibold z-20"
            onClick={() => sendInvite()}
          >
            Join
          </button>
        </div>
      </>
    );
  }

  function DisplayComponent() {
    return (
      <>
        <Modal centered open={commentId.length > 0} footer={null}>
          <div
            style={{
              padding: "0 16px",
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
              gap: 8,
            }}
          >
            <h1 className=" text-2xl text-center text-SocoWhite p-0">Help us help you...</h1>
            <label htmlFor="what" className="mb-1 w-full text-SocoWhite">
              What services does your business offer?
            </label>
            <input
              type="text"
              name="what"
              id="what"
              className=" rounded-full w-full h-10 p-5 text-center text-SocoBlack"
              ref={What}
            />
            <br />
            <label htmlFor="how" className="mb-1 w-full text-SocoWhite">
              What would make your business more profitable and secure?
            </label>
            <input
              type="text"
              name="how"
              id="how"
              className=" rounded-full w-full h-10 p-5 text-center text-SocoBlack"
              ref={How}
            />
            <br />
            <label className="w-full text-SocoWhite">
              Are you ready to take your freelancing career to the next level?
            </label>
            <div className="my-5 w-full lg:w-1/2 flex flex-row gap-4">
              <button
                onClick={() => {
                  showComment("");
                }}
                className="h-14 w-32 rounded-full border-2 border-SocoOrangeLight font-semibold"
              >
                No, skip :(
              </button>
              <button
                onClick={addComment}
                className="h-14 w-32 rounded-full bg-SocoOrangeLight text-SocoBlack font-semibold"
              >
                Yes, submit!
              </button>
            </div>
          </div>
        </Modal>
        <h1 className=" text-4xl font-semibold mt-12 mb-5 text-center text-SocoBlack">
          Welcome
        </h1>
        <h2 className="mb-2 text-center text-xl text-SocoBlack">
          {details?.name}
        </h2>
        <p className="mb-2 px-2 md:w-1/3 xl:w-1/3 text-center text-SocoBlack">
          We'll be sending you an invite link to your email within 24 hours:{" "}
        </p>
        <span className="text-SocoBlack font-bold">{details?.email}</span>
        <SiMinutemailer className="fill-SocoWhite my-5 px-2 h-16 w-16" />
      </>
    );
  }

  const ComponentSwitch = joinTrigger ? (
    <>
      <DisplayComponent />
    </>
  ) : (
    <>
      <FormComponent />
    </>
  );

  const backgroundSwitch = joinTrigger ? "bg-Soco" : "bg-SocoOutline";

  return (
    <div
      className="flex flex-col relative justify-center items-center w-full mb-40 mt-40"
      id="contact"
    >
      {/* testimonials /reviews */}

      {/* contact form */}
      <div
        className={`p-10 relative w-4/5 xl:w-2/3 flex flex-col items-center text-SocoWhite ${backgroundSwitch} bg-contain bg-no-repeat bg-center`}
      >
        {ComponentSwitch}
      </div>
    </div>
  );
}

export default Contact;
